/** The four resource types. Order is canonical (used by ResourceBag / track). */
export const RESOURCES = ["minerals", "food", "vigor", "obsidian"];
//# sourceMappingURL=resource.js.map